import {isEqual} from 'lodash';

export function equal(object1: unknown, object2: unknown) {
  return isEqual(object1, object2);
}